import { colorOrToken, Typography, tokens } from '@cast/design-system';

export const InlineCode = ({ children }: { children: string }) => (
  <Typography
    component="code"
    variant="C12"
    sx={{
      bgcolor: colorOrToken('grey.200', tokens.theme.bg.structural.code),
      border: '1px solid',
      borderColor: tokens.theme.border.structural.neutralStrong,
      borderRadius: '2px',
      color: colorOrToken(
        'grey.600',
        tokens.theme.fg.structural.primaryOnInverse
      ),
      px: '4px',
    }}
  >
    {children}
  </Typography>
);
